import { ComponentProps } from "react";
export const isMobile = window.matchMedia("(max-width: 767px)").matches;

interface ButtonGoFinalChatProps extends ComponentProps<"button"> {}

export function ButtonGoFinalChat({ ...rest }: ButtonGoFinalChatProps) {
  return (
    <div
      className="position-absolute"
      style={{
        bottom: isMobile ? 100 : 120,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 999,
      }}
    >
      <button
        className="btn btn-sm btn-secondary rounded-circle d-flex justify-content-center align-items-center"
        style={{
          width: 40,
          height: 40,
        }}
        aria-label="Scroll to bottom of chat"
        {...rest}
      >
        <i className="bx bx-down-arrow-alt font-size-24" />
      </button>
    </div>
  );
}
